import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API;

const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/sessions`, {
      username,
      password,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const logout = (navigate) => {
  localStorage.removeItem('username');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  navigate('/');
};

const authService = {
  login,
  logout,
};

export default authService;